import ServerSettings, {ServerSettingsFieldType} from "../../gd/settings/server-settings/server-settings";
import {UsersSelectorGroupBy} from "../../fields3/generic/users/@const";

const fieldsConfig = {
    'usersSelectorGroupBy': {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : UsersSelectorGroupBy.NONE,
        options         : [UsersSelectorGroupBy.NONE, UsersSelectorGroupBy.DEPARTMENT, UsersSelectorGroupBy.TEAMS]

    },
}

// const debug = 'UserSettings_Interface'
const debug = false

// Misc Interface settings here

export default class UserSettings_Interface extends ServerSettings {

    public usersSelectorGroupBy             : UsersSelectorGroupBy = UsersSelectorGroupBy.NONE

    constructor(config: JSONObject) {
        super(config, fieldsConfig)

        debug && console.log(debug, 'constructor', config)

        this.usersSelectorGroupBy           = this.initValue('usersSelectorGroupBy')
    }

    toJson() {
        const result = {}
        this.valueToJson(result, 'usersSelectorGroupBy')

        return result
    }
}
